import { render, staticRenderFns } from "./RxDragRow.vue?vue&type=template&id=56a12d3a&scoped=true&lang=pug&"
import script from "./RxDragRow.vue?vue&type=script&lang=ts&"
export * from "./RxDragRow.vue?vue&type=script&lang=ts&"
import style0 from "./RxDragRow.vue?vue&type=style&index=0&id=56a12d3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a12d3a",
  null
  
)

component.options.__file = "RxDragRow.vue"
export default component.exports